module.exports = __webpack_public_path__ + "static/media/vacasa-logo-horizontal-blue.2887851c.svg";